import React, { useEffect, useState, useContext } from 'react';
import '../PendingForReviewToll/violationforplazareviewlisting.css'
import Table from 'react-bootstrap/Table'
import './assignedtomelisting.css'
import { getGridDataForAssigntome, unAssignmentPopupData, getAuditGridData, getPlazaTAT} from '../../../common/apiService'
import CommonDateRangePicker from '../../../common/daterangepicker'
import CustomPagination from '../../../common/custom_pagination'

import Loader from 'react-loader-spinner';
import Moment from 'moment'
import SelectSearch, { fuzzySearch } from "react-select-search";
import { BsArrowDown, BsArrowUp, BsFileEarmarkText } from 'react-icons/bs'
import Selfassignpopupscreenui from '../dashboard/selfassignpopupscreenui'
import CaseReviewScreenPopup from '../CaseReviewScreenPopup/casereviewscreenpopup'
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify'
import { isNumberWithoutDecimal } from '../../../service/utilService'
import UploadEditFilesAndImages from '../uploadfiles/uploadeditfilesandimages'
import '../../../common/selectsearch.css'
import { exportToExcel } from '../../../service/utilService';
// import SubmittedPopup from '../uploadfiles/submittedPopup'
import AuditLogDetailPopup from '../../Contents/auditlogdetailpopup'
import { getJsonData } from '../../../service/utilService'
import { FaSearch, FaSpinner } from 'react-icons/fa';
import { UserContext } from '../../../contexts/UserContext';


export default function AssignedToMeListing({ origin, globalviolationdata, setGlobalAssignedToMe, globalassignedtome }) {
    const userDetail = useContext(UserContext);
    const [downloaddata, setDownloadedData] = useState([]);
    const [gridList, setGridList] = useState([]);
    const [jsonData, setJsonData] = useState(getJsonData(userDetail));
    const [totalPage, setTotalPage] = useState(0);
    const [currentPage, setCurrentPage] = useState("0");
    const [Show1, setShow1] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showModel, setShowModel] = useState(false);
    const [currentViolationIndex, setCurrentViolationIndex] = useState("0");
    const [show2, setShow2] = useState(false);
    const [unassigncount, setUnassigncount] = useState("");
    const [allassignviolation, setAllassignViolation] = useState(false);
    const [showuploadmodel, setShowUploadModel] = useState(false);
    const [showbuttons, setShowButtons] = useState(false);
    const [vioStatus, setSetVioStatus] = useState('""');
    const [totalGridData, setTotalGridData] = useState(0);  
    const [violationtype, setVioType] = useState("Assigned Violations for review");
    const [showAuditLogPopup, setShowAuditLogPopup] = useState(false);
    const [auditpopupgridList, setAuditPopupGridList] = useState([]);
    const [selectedrrnno, setSelectedRrnNo] = useState(0);
    const [finalGridList, setGridListFinal] = useState([]);
    const [etaData, setETAData] = useState('""');
    const [etaArray, setEtaArray] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [plazaTAT, setPlazaTAT] = useState(0);
    const [tollplaza, setTollPlaza] = useState("");

    useEffect(() => {
        if(userDetail?.plaza!==null && userDetail?.plaza!==""){
            setTimeout(() => setTollPlaza(userDetail?.plaza),100)
        }
        }, [userDetail])


    useEffect(() => {
        if (tollplaza) {
            const timer = setTimeout(() => {
                griddata();
            }, 100);
    
            return () => clearTimeout(timer);  // Cleanup on component unmount
        }
    }, [tollplaza]);

    const getTATData = ()=> {
        getPlazaTAT().then(res =>{                    
                        if (res) {

                            setPlazaTAT(res.data);
                            
                        }

                    }).catch(err=>{
                        console.log("Get Plaza TAT API Error "+err);
                    })
    }

    let etadropdownData = [
        { name: '3 & Less', value: '3 & Less' },
        { name: '24-48', value: '24-48' },
        { name: '48 & more', value: '48 & more' }
    ];
    let violationstatusData = [
        { name: 'All', value: '""' },
        { name: 'Wrong Image', value: 'Wrong Image' },
        { name: 'Image Not Clear', value: 'Image Not Clear' },
        { name: 'Image Not Found', value: 'Image Not Found' },
        { name: 'Rejected by model', value: 'Rejected by model' },
        { name: 'NPCI Class is correct', value: 'NPCI Class is correct' },
        { name: 'As per RC issuance is correct', value: 'As per RC issuance is correct'},
        { name: 'NPCI Class is Correct-System', value: 'NPCI Class is Correct-System'}
        
    ];
    const [sortedby, setSortedBy] = useState('');
    const [orderby, setOrderBy] = useState('asc');

    useEffect(() => {
        let interval;
        if (gridList.length > 0) {
            let etaArr = [];
            gridList.forEach(e => {
                const timer = getCountDownTime(e.plazaMark, e.readerReadTime);
                etaArr.push(timer);
            })
            setEtaArray(etaArr);
            interval = setInterval(() => {
                let etaArr = [];
                gridList.forEach(e => {
                    const timer = getCountDownTime(e.plazaMark, e.readerReadTime);
                    etaArr.push(timer);
                })
                setEtaArray(etaArr);
            }, 1000)
        }
        return () => {
            clearInterval(interval);
        }
    }, [gridList])

    const griddata = async (searchTxt) => {
        setLoading(true);
        const { headerJson, bodyJson, paramJson } = getJson();
        if (searchTxt) {
            headerJson.searchText = searchTxt;
            paramJson.offset = 0; }
        try {
            getTATData();
            const res = await getGridDataForAssigntome(headerJson, bodyJson, paramJson);
            const data = res.data.data;
            if (data.length > 0) {
                let istTime = new Date();
                //let istTime = new Date(currentTime + 5.5 * 60 * 60 * 1000);
                const tat = parseInt(plazaTAT);
                const tatMins = tat * 60;

                const filteredGrid1 = data.filter(row => {
                    if (!row.plazaMark) {
                        return false
                    }
                    //const numberPlaza = diff_hours(new Date(), new Date(row.plazaMark) );
                    const numberBank = diff_hours(istTime, new Date(row.readerReadTime) );
                    const MinValNum = (tatMins - numberBank)-330;

                    if (MinValNum <= 0) {
                        return false
                    }
                    return MinValNum;
                });
                const filteredGrid2 = data.filter(row => !filteredGrid1.includes(row))
                const sortdata = filteredGrid1.sort((a, b) => diff_hours(new Date(a.readerReadTime), new Date(b.readerReadTime) ));
                const finalGrid = [...sortdata, ...filteredGrid2];
                setGridList(finalGrid);
            } else {
                setGridList([]);
            }
            const totalpages = res.data.pages;
            setTotalPage(totalpages);
            setTotalGridData(res.data.totalElements)
            setLoading(false);
            setGlobalAssignedToMe(res.data.data.length)
        } catch {
            setTotalPage(0);
            setTotalGridData(0)
            setLoading(false);
            setGlobalAssignedToMe(0);
            setGridList([]);
        }
        // downloadfile(vioStatus);
    }

    useEffect(() => {
        if (showModel === false && showuploadmodel === false) {
            griddata();
        }
    }, [jsonData, vioStatus, etaData])

    useEffect(() => {
        if( document.getElementById("chkAll")) {
        document.getElementById("chkAll").checked=false;
        gridList.forEach((e, i) => {
            document.getElementById("chk" + i).checked = false;
        })
        setShowButtons(false);
        setDownloadedData([]); }
    }, [currentPage])

    useEffect(() => {
        if (currentPage !== "0")
            griddata(searchText);
    
        // eslint-disable-next-line
        // if (searchText)
        //     setCurrentPage("0");
    }, [currentPage, searchText])

    useEffect(() => {
        if (sortedby !== "")
            griddata();
        // eslint-disable-next-line
    }, [sortedby, orderby, vioStatus]);



    const setUnAssignCountValue = (val) => {
        if (isNumberWithoutDecimal(val))
            setUnassigncount(val);
    }
    const setAllViolation = (flag) => {
        if (flag)
            setUnassigncount(totalGridData);
        else
            setUnassigncount("");
        setAllassignViolation(flag)

    }

    const unassignViolation = () => {
        setLoading(true);
        if (Number(unassigncount) > Number(totalGridData)) {
            toast.warning("Violation count should not be greater-than Assigned me Violations!");
            return;
        }
        const bodyjson = {
            cases: Number(unassigncount) || 0,
            plazaIds: Array.isArray(jsonData.plazaIds) ? jsonData.plazaIds.join(",") : jsonData.plazaIds
        };
        
        unAssignmentPopupData(bodyjson).then(res => {
            griddata();
        });
        /* const headerjson = {
            plazaids: jsonData.plazaIds || userDetail.plaza,
            cases: unassigncount
        }
        const bodyjson = {
            cases: unassigncount
        }
        unAssignmentPopupData(headerjson).then(res => {
            griddata();
        }); */
        setUnassigncount('');
        setShow2(false)
        setLoading(false);
        if (origin === "assign") {
            // updateActiveCount(activeCount + +unassigncount);
        } else if (origin === "dashboardassign") {
            // updateActiveCount(activeCount + +unassigncount);
            setGlobalAssignedToMe(globalassignedtome - unassigncount);
        }
    }

    const miliseconds = (time) => {
        return ((time[0] * 60 * 60 + time[1] * 60 + time[2]) * 1000);
    }

    const diff_hours = (dt2, dt1) =>{
       var diff =(dt2.getTime() - dt1.getTime()) / 1000;
        diff /= (60);
       return Math.abs(Math.round(diff));
        // return difference in minutes
     }

    const getCountDownTime = (plazatime, readerredtime) => {
        if (!plazatime) {
            return "Expired";
        }
        const tat = parseInt(plazaTAT);
        
        const tatMins = tat * 60;
        const oneDay = 24 * 60 * 60 * 1000;
        let istTime = new Date();
        //let istTime = new Date(currentTime + 5.5 * 60 * 60 * 1000);
        //const numberPlaza = diff_hours(new Date(), new Date(plazatime) );
        const numberBank = diff_hours(istTime, new Date(readerredtime) );
        const MinValNum = (tatMins - numberBank)-330;
        
        if (MinValNum <= 0) {
            return "Expired";
        }
        var milliseconds = MinValNum;
        var dateCus = new Date();
        dateCus.setDate(dateCus.getDate() - MinValNum);

        const rrt = new Date(plazatime.replace(".000+0000", ""));
        const d1 = milliseconds;
        const d2 = new Date() - rrt;
        // if (d2 >= d1)
        //     return "Expired";
        const duration = milliseconds ;

        let seconds = Math.floor((duration / 1000) % 60),
            minutes = Math.floor((duration / (1000 * 60)) % 60),
            hours = Math.floor((duration / (1000 * 60 * 60)) % 24),
            day = Math.floor((duration / (1000 * 60 * 60 * 24)));
        hours = (hours < 10) ? "0" + hours : hours;
        minutes = (minutes < 10) ? "0" + minutes : minutes;
        seconds = (seconds < 10) ? "0" + seconds : seconds;

        if(duration >= 120){

            return (duration/60).toFixed(0);
            }
        else {

            return duration >= 60 ?  "01:"+((duration-60).toString().padStart(2,0)) : "00:"+duration.toString().padStart(2,0);
        }
    }

    const getCountDownTimeOld = (plazatime, readerredtime) => {
        if (!plazatime) {
            return "Expired";
        }
        const tat = parseInt(plazaTAT);
        const tatMinuts = tat * 60;
        const oneDay = 24 * 60 * 60 * 1000;
        const numberPlaza = diff_hours(new Date(), new Date(plazatime) );
        const numberBank = diff_hours(new Date(), new Date(readerredtime) );
        const MinValNum = Math.min(5760 - numberBank, 2880 - numberPlaza) - 330;
        if (MinValNum <= 0) {
            return "Expired";
        }
        var milliseconds = MinValNum;
        var dateCus = new Date();
        dateCus.setDate(dateCus.getDate() - MinValNum);

        const rrt = new Date(plazatime.replace(".000+0000", ""));
        const d1 = milliseconds;
        const d2 = new Date() - rrt;
        // if (d2 >= d1)
        //     return "Expired";
        const duration = milliseconds ;
        
        let seconds = Math.floor((duration / 1000) % 60),
            minutes = Math.floor((duration / (1000 * 60)) % 60),
            hours = Math.floor((duration / (1000 * 60 * 60)) % 24),
            day = Math.floor((duration / (1000 * 60 * 60 * 24)));
        hours = (hours < 10) ? "0" + hours : hours;
        minutes = (minutes < 10) ? "0" + minutes : minutes;
        seconds = (seconds < 10) ? "0" + seconds : seconds;

        if(duration >= 120)
            return (duration/60).toFixed(0);
        else {
            return duration >= 60 ?  "01:"+((duration-60).toString().padStart(2,0)) : "00:"+duration.toString().padStart(2,0);
        }
    }

    const getJson = () => {
        const bodyJson = {
            // adjType: "DA",
            mapped_avc: "",   
            plazaIds: Array.isArray(jsonData.plazaIds) ? jsonData.plazaIds.join(",") : jsonData.plazaIds   
        }
        const { plazaIds, ...restJsonData } = jsonData; // Remove plazaIds from jsonData before adding it to headerJson
        const headerJson = {
            ViolationStatus: vioStatus,
            searchText,
            ...restJsonData

        }
        const paramJson = {
            offset: currentPage,
            limit: '150',
            sort_c: sortedby,
            sort_t: orderby
        }
        const json = {
            bodyJson: bodyJson,
            headerJson: headerJson,
            paramJson: paramJson
        }
        return json;
    }

    const gridShort = (val) => {
        if (val !== sortedby) {
            setSortedBy(val);
            setOrderBy('asc');
        } else {
            if (orderby === 'asc')
                setOrderBy('desc');
            else
                setOrderBy('asc')
        }
    }

    const arrow = (val) => {
        if (val === sortedby && orderby === 'asc')
            return (<BsArrowDown className="sort-arrow" />);
        else if (val === sortedby && orderby === 'desc')
            return (<BsArrowUp className="sort-arrow" />)
    }

    const openModal = (index) => {
        setShowModel(true);
        setCurrentViolationIndex(index);
    }

    const checkAll = () => {
        const status = document.getElementById("chkAll").checked;
        gridList.forEach((e, i) => {
            document.getElementById("chk" + i).checked = status;
        })
        setDownloadedData(status ? [...gridList] : []);
        setShowButtons(status);
    }

    const setexcelData = (evt, e) => {
        if (evt.target.checked) {
            setShowButtons(true);
            downloaddata.push(e);
        } else {
            if (downloaddata.length === 1)
                setShowButtons(false)
            const index = downloaddata.indexOf(e);
            downloaddata.splice(index, 1);
        }
        setDownloadedData(downloaddata);
        document.getElementById("chkAll").checked = (downloaddata.length === gridList.length) ? true : false;
    }



    const downloadexcel = () => {
        exportToExcel(downloaddata, "jsondata", "Assigned To Me_" + downloaddata.length + " row");
    }

    const getAuditPopupGridData = (row) => {
        const caseId = row.id;
        setSelectedRrnNo(row.rrn);
        setLoading(true);
        getAuditGridData(caseId).then(res => {
            setGridListFinal([]);
            res.data.forEach(function (item, index) {
                if (item.updatedColumns?.length > 0) {
                    item.updatedColumns.forEach(function (items, indexs) {
                    
                        if (items === 'Remark' || items === 'AssignedUserID' || items === 'Maker_Attempt' || items === 'Checker_Attempt' || items === 'Case_Status_Description' || items === 'case_life' || items === 'plaza_date_mark' || items === 'bank_date_mark' || items === 'expired_dt') {
                            finalGridList.push({ "datetime": item.modifiedDate, "from": item.oldData[items], "to": item.newData[items], "colmname": items })
                        }
                    });
                }
            });

            setLoading(false);

            if (res.data && res.data !== "No record Found!")
                setAuditPopupGridList(finalGridList);
            else
                setAuditPopupGridList([]);
            setShowAuditLogPopup(true);
        }).catch(err => {
            setLoading(false);
        })
    }


    const getETAClass = (e, index) => {

        const timer = etaArray.length ? etaArray[index] : getCountDownTime(e.plazaMark, e.readerReadTime);
        let hr = timer;
        // if (timer) {
        //     hr = timer.split(":")[0];
        // }
        if (hr > 96) return "fifthday-eta";
        if (hr > 72) return "fourthday-eta";
        if (hr > 48) return "thirdday-eta";
        if (hr > 24) return "secondday-eta";
        if (hr > 12) return "first_secondhalfday-eta";
        else return "first_firsthalfday-eta";
    }

    const getETACountDown = (e, index) => {
        if (etaArray.length)
            return etaArray[index]
        else
            return getCountDownTime(e.plazaMark, e.readerReadTime)
    }


    const gridfilter = (evt) => {
        
        const value = evt.target.value;
        if (evt.key === 'Enter') {
            if (value) {
            
                setSearchText(value.trim());
                griddata(value.trim());
                
            } else {
                
                setSearchText("");
                griddata(value.trim());
            }
        }
    }

    return (
        <>

            {/* Un-Assign Popup Start */}
            <Modal show={show2} onHide={() => setShow2(false)} size="md" id="modal2" centered>
                <Modal.Body>
                    <div className="modalbody-left">
                        Un-assignment
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ border: 'none', display: 'block' }}>
                    <input type="checkbox" checked={allassignviolation} onChange={(e) => { setAllViolation(e.target.checked) }} /> &nbsp; <span style={{ fontSize: 15, color: '#707070' }} >All assigned violations</span>
                    <input type="text" value={unassigncount} maxLength="5" onChange={(e) => setUnAssignCountValue(e.target.value)} className="form-control unassignmentcount" />
                    <br /><br /><br />
                    <div className="modelfooter-btn2">
                        <Button variant="secondary" onClick={() => setShow2(false)}>
                            CANCEL
                        </Button> &nbsp; &nbsp;
                        <Button variant="primary" disabled={unassigncount > 0 ? false : true} style={{ backgroundColor: '#F99600', border: 'none', position: 'relative' }} onClick={unassignViolation}>
                            UNASSIGN {loading && <FaSpinner icon="spinner" spin className="spinner" />}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            {/* Un-Assign Popup End */}


            <Selfassignpopupscreenui
                activeCount={0}
                show1={Show1}
                setShow1={setShow1}
            />
           {showModel && <CaseReviewScreenPopup
                showModel={showModel}
                setShowModel={setShowModel}
                parentGridData={gridList}
                setParentGridData={setGridList}
                violationtype={violationtype}
                index={currentViolationIndex}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                totalPage={totalPage}
                setGlobalAssignedToMe={setGlobalAssignedToMe}
                globalassignedtome={globalassignedtome}
                etaArray={etaArray}
                setEtaArray={setEtaArray}
                setTotalGridData={setTotalGridData}
            />
           }
            <Loader className="loader"
                type="ThreeDots"
                color="#9c1d26"
                height={100}
                width={100}
                visible={loading}
                style={{ backgroundColor: 'lightgrey' }} />

            <UploadEditFilesAndImages
                showuploadmodel={showuploadmodel}
                setShowUploadModel={setShowUploadModel}
                setLoading={setLoading}
                loading={loading} />

            <AuditLogDetailPopup
                setShowAuditLogPopup={setShowAuditLogPopup}
                showAuditLogPopup={showAuditLogPopup}
                gridList={auditpopupgridList}
                selectedrrnno={selectedrrnno}
            />

            <div className="container-fluid assignMakers">
                <div className="row">
                    <div className="col-md-5">
                        <h3>{violationtype}  {userDetail.roles?.includes('checker') ? <span>for recheck</span> : null}  </h3>
                        <span>(To perform bulk action select "Image Not Found" from Violation Status filter)</span>
                    </div>
                    <div className="col-md-4">
                    </div>
                    { vioStatus === 'Image Not Found' ? <div className="col-md-3">
                        {showbuttons && <>
                            <button className="uploadbtn" onClick={() => setShowUploadModel(true)}>Upload File</button>
                            <button className="uploadbtn" style={{ background: '#707070' }} onClick={downloadexcel}>Download  File</button>
                        </>}
                    </div> : null}
                </div>
            </div>
            <div className="container-fluid">
                <div className="col-md-12">
                    <div className="row filterssrtip">
                        <div className="col-md-4 row">
                            <div className="col-md-8">

                                <h4 className="lowh3">Violation assigned to me - <span>{totalGridData}</span>

                                </h4>
                            </div>
                            <div className="col-md-2">
                                <button className="viewdetailbtn unassignbutton" onClick={() => setShow2(true)}>Unassign</button>
                            </div>
                        </div>
                        <div className="col-md-8 option assign-to-me-plazadropdown">

                            {/* <div className="dwd" onClick={downloadexcel}>
                                <i class="bi bi-download download"></i>
                            </div> */}
                            <CommonDateRangePicker
                                plazaClassName="tollfilter"
                                datepickerClassName="daterange"
                                setjsonData={setJsonData}
                                showDateRangePicker={true}
                            />
                            <div className="violationstatusfilter">
                                <SelectSearch
                                    options={violationstatusData}
                                    search
                                    filterOptions={fuzzySearch}
                                    // multiple="true"
                                    placeholder="Violation Status"
                                    value={vioStatus}
                                    onChange={(selectedValue) => setSetVioStatus(selectedValue)}
                                />
                            </div>
                            {/* <div className="etafilter" >
                                <SelectSearch style={{ width: 100 }}
                                    options={etadropdownData}
                                    search
                                    filterOptions={fuzzySearch}
                                    placeholder="ETA"
                                    onChange={(selectedValue) => setETAData(selectedValue)}
                                />
                            </div> */}
                            <div className="searchbar">
                                <input className="form-control" onChange={e => setSearchText(e.target.value)} onKeyPress={gridfilter} placeholder="Search RRN & TAG" />
                                {searchText ? <FaSearch onClick={() => griddata()} /> : <FaSearch />}
                            </div>
                        </div>

                    </div>
                    <div style={{ maxHeight: 600, overflowX: 'auto', width: '100%', marginBottom: 10 }}>
                        <Table striped bordered hover variant="light" className="customTable">
                            <thead>
                                <tr className="pointer" style={{ position: 'sticky', top: -1 }}>
                                  { vioStatus === 'Image Not Found' ?  <th><input type="checkbox" name="" id="chkAll" onClick={checkAll} /></th> : null }
                                    <th>RRN </th>
                                    <th>Tag ID </th>
                                    <th>Reader Read Time </th>
                                    <th>Mapped AVC </th>
                                    <th>NPCI VC </th>
                                    <th>Status </th>
                                    <th>Status Remarks </th>
                                    <th>ETA Hours </th>
                                    <th></th>

                                </tr>
                            </thead>
                            <tbody>
                                {gridList?.length > 0 ?
                                    gridList.map((e, index) => {
                                        return (
                                            getETACountDown(e, index) !=='Expired' &&
                                            <tr className="pointer">
                                                { vioStatus === 'Image Not Found' ?  <td><input type="checkbox" name="" id={"chk" + index} onChange={(evt) => setexcelData(evt, e)} /></td> : null }
                                                <td onClick={() => openModal(index)}>{e.rrn}</td>
                                                <td onClick={() => openModal(index)}>{e.tagId}</td>
                                                <td onClick={() => openModal(index)}>{Moment.utc(e.readerReadTime).format("yyyy.MM.DD, hh:mm:ss A")}</td>
                                                <td onClick={() => openModal(index)}>{e.mappedAvc}</td>
                                                <td onClick={() => openModal(index)}>{e.npciVehicleClass}</td>
                                                <td onClick={() => openModal(index)}> {e.status}</td>
                                                <td onClick={() => openModal(index)}>{e.remark}</td>
                                                <td onClick={() => openModal(index)} className='eta_th_column'><span className={"etablock " + getETAClass(e, index)}>{getETACountDown(e, index)}</span></td>
                                                <td style={{ width: 60, cursor: 'auto', padding: '7px 15px' }} >
                                                    <div className="ripple"
                                                        onClick={() => getAuditPopupGridData(e)}>
                                                        <BsFileEarmarkText title="Log details" className="auditbtn edit" />
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                    :
                                    <tr>
                                        <td colSpan="10" style={{ textAlign: 'center' }}>Data Not Found!</td>
                                    </tr>
                                }
                            </tbody>
                        </Table>
                    </div>
                    <CustomPagination
                        currentPage={currentPage}
                        totalPage={totalPage}
                        setCurrentPage={setCurrentPage}
                    />
                </div>
            </div>
        </>
    )
}
